/** @jsx jsx */
import { jsx } from '@emotion/core'
import { LabelHTMLAttributes } from 'react'
import { FunctionComponent, HTMLAttributes } from 'react'
import { colors, typeRamp } from '../../constants'
import {
	InputValidationState,
	INPUT_VALIDATION_STATE_INVALID,
} from './constants'

interface Props extends HTMLAttributes<HTMLDivElement> {
	inputID: string
	label: string
	labelProps?: LabelHTMLAttributes<HTMLLabelElement>

	// Validation
	validationState?: InputValidationState
	invalidMessage?: string
	validMessage?: string
}

const FormField: FunctionComponent<Props> = ({
	children,
	inputID,
	label,
	labelProps,
	validationState,
	invalidMessage,
	validMessage,
	...props
}) => {
	return (
		<div {...props}>
			<label
				css={{
					...(typeRamp.med_16 as any),
					marginBottom: '1rem',
				}}
				htmlFor={inputID}
				{...labelProps}
			>
				{label}
			</label>
			<div>{children}</div>

			{validationState === INPUT_VALIDATION_STATE_INVALID && invalidMessage && (
				<div
					css={{
						...(typeRamp.light_16 as any),
						paddingTop: '0.5rem',
					}}
				>
					<span
						css={{
							background: colors.citron,
						}}
					>
						{invalidMessage}
					</span>
				</div>
			)}
		</div>
	)
}

export default FormField
